module.exports = __webpack_public_path__ + "img/bg1.84912c00.jpg";